export class InvestigationFormFieldEntity {
  public id!: string;
  public name!: string;
  public label!: string;
  public helperText?: string;
  public placeholder?: string;
  public fieldType!: InvestigationFormFieldType;
  public isRequired!: boolean;
  public isVisibleToRequester?: boolean;
  public isHiddenByDefault?: boolean;
  public isSystem!: boolean;
  public sensitivityCategory?: string | null;
  public visibilityRule?: InvestigationFormFieldVisibilityRule | null;
  public sortOrder!: number;
  public options?: string[];
  public defaultValue?: string;
  public validationRules?: Record<string, unknown>;
  public constraints?: InvestigationFormFieldConstraint[];
}

export interface InvestigationFormFieldVisibilityRule {
  sourceFieldId: string;
  operator: string;
  value: string;
  show: boolean;
}

export interface InvestigationFormFieldConstraint {
  typeConstraintId: string;
  constraintKey: string;
  value: string;
  label: string;
  valueType: string;
  defaultValue: string | null;
}

export type InvestigationFormFieldType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'email'
  | 'date'
  | 'select'
  | 'checkbox'
  | 'checkboxes'
  | 'radio'
  | 'radio_buttons'
  | 'file'
  | 'file_upload'
  | 'currency'
  | 'time'
  | 'yes_no';
